jQuery(document).ready(function () {
    /*
     * this filter is intended to work only on recipes/rezepte page
     * that is why we use the header-dierezepte class
     */
    jQuery(".header-dierezepte #select-droplist a").click(function (e) {
        e.preventDefault();
        let product_category = jQuery(this).data("rezepte");

        if (product_category === "reset") {
            jQuery(".recipes-card a").show();
            return;
        }

        jQuery(".recipes-card a").hide();
        jQuery(`.recipes-card a[data-kategories="${product_category}"]`).show();
    });
})
